import * as REDUX_TYPES from '../types'

export const getDisplayType = () => {
  const parts = window.location.hostname.toLowerCase().split('.')

  const local = parts[parts.length - 1] === 'localhost'
  return { harmonize: true, vortex: false, local }
}


export const setAllowSwipe = (allowSwipe) => {
  return {
    type: REDUX_TYPES.DISPLAY.ALLOW_SWIPE,
    allowSwipe
  }
}


export const setContainDisplay = (containDisplay) => {
  return {
    type: REDUX_TYPES.DISPLAY.CONTAIN_DISPLAY,
    containDisplay,
  }
}

export const setContinuousPlay = (continuousPlay) => {
  return {
    type: REDUX_TYPES.DISPLAY.CONTINUOUS_PLAY,
    continuousPlay,
  }
}

export const setReactorPlay = (reactorPlay) => {
  return {
    type: REDUX_TYPES.DISPLAY.REACTOR_PLAY,
    reactorPlay,
  }
}

export const setShowSearch = (showSearch) => {
  return {
    type: REDUX_TYPES.DISPLAY.SHOW_SEARCH,
    showSearch,
  }
}

export const setTransactionInProgress = (transactionInProgress) => {
  return {
    type: REDUX_TYPES.DISPLAY.TRANSACTION_IN_PROGRESS,
    transactionInProgress,
  }
}

